import "core-js/modules/es.number.constructor.js";
import BaseBtModal from "@vueEntry/BaseBtModal.vue";
import { defineComponent } from "vue";
import BaseAlert from "@vueEntry/UIKitComponents/BaseAlert.vue";
export default defineComponent({
  name: "GenericSuccessModal",
  components: {
    BaseBtModal: BaseBtModal,
    BaseAlert: BaseAlert
  },
  props: {
    showModal: {
      type: Boolean,
      "default": false
    },
    labels: {
      type: Object,
      required: true
    },
    autoClose: {
      type: Number,
      "default": null
    }
  },
  emits: ["opened", "closed"],
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    console.log("created di success modal");
    this.show = this.showModal;
  },
  methods: {
    onOpened: function onOpened() {
      this.$emit("opened");
    },
    onClosed: function onClosed() {
      this.$emit("closed");
    }
  }
});